export const paths = {
  root: "/",
  dashboard: {
    root: "/dashboard",
    preview: {
      root: "/dashboard/preview",
      view: (preview: any) => `/dashboard/preview/${preview._id}`,
    },
    apps: {
      root: "/dashboard/apps",
      view: (app: any) => `/dashboard/apps/${app._id}`,
    },
    agents: {
      root: "/dashboard/agents",
      view: (agent: any) => `/dashboard/agents/${agent._id}`,
    },
    workflows: {
      root: "/dashboard/workflows",
      view: (workflow: any) => `/dashboard/workflows/${workflow._id}`,
    },
    integrations: {
      root: "/dashboard/integrations",
      view: (integration: any) => `/dashboard/integrations/${integration._id}`,
    },
    evals: {
      root: "/dashboard/governance/evals",
      view: (evalItem: any) => `/dashboard/governance/evals/${evalItem._id}`,
    },
  },
};
